<template>
  <v-card>
    <v-toolbar color="secondary" class="elevation-0">
      <v-toolbar-title> Instances </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        disable-sort
        dense
        disable-pagination
        hide-default-footer
      />
      <!-- @click:row="openDetail" -->
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    loading: false,
    headers: [
      { text: "Name", value: "name" },
      { text: "Location", value: "location" },
      { text: "URL", value: "url" },
    ],
  }),

  computed: {
    ...mapGetters(["instances"]),
    items() {
      return this.instances?.map((i) => ({
        name: i.name,
        location: i.country_code,
        url: i.url,
        details: i,
      }));
    },
  },

  methods: {
    openDetail(item) {
      this.$router.push("/instances/" + item.details.uid);
    },
  },
};
</script>
